.themed-report-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 100%;
}

.report-summary {
  margin-bottom: 0;
}

.report-summary h2 {
  margin-bottom: 0.5rem;
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--header-text-color);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.report-summary h2::before {
  content: "📊";
  font-size: 1.5rem;
}

.themes-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.themes-section h2 {
  margin-bottom: 0.5rem;
  font-size: 1.75rem;
  font-weight: 600;
  color: var(--header-text-color);
  text-align: center;
  position: relative;
  padding-bottom: 0.25rem;
}

.themes-section h2::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 2px;
  background: var(--main-blue);
  opacity: 0.3;
}

.theme {
  margin-bottom: 1rem;
}

.theme h3 {
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--section-header-text-color);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.theme h3::before {
  content: "🎯";
  font-size: 1.25rem;
}

.theme-summary {
  padding: 0.75rem;
  margin-bottom: 0.75rem;
  border-radius: 4px;
}

.theme-risks,
.theme-actions {
  margin-bottom: 0.75rem;
  padding: 0.75rem;
  border-radius: 4px;
}

.theme-risks {
  background: rgba(231, 76, 60, 0.03);
}

.theme-actions {
  background: rgba(39, 174, 96, 0.03);
}

.theme-risks h4,
.theme-actions h4 {
  margin-bottom: 0.5rem;
  font-size: 1rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-transform: uppercase;
}

.theme-risks h4 {
  color: #c0392b;
}

.theme-risks h4::before {
  content: "⚠️";
  font-size: 1rem;
}

.theme-actions h4 {
  color: #229954;
}

.theme-actions h4::before {
  content: "✅";
  font-size: 1rem;
}

.map-section {
  margin: 0.75rem 0;
  padding: 0;
  border: none;
  border-radius: 0;
  background-color: transparent;
}
